module.exports = __webpack_public_path__ + "img/A2F10.84beeefe.jpg";